import type { TimespentResponse } from '../../lib/api'
import { formatDuration } from '../../lib/format'

interface Props { data: TimespentResponse | null; loading?: boolean }

export function TimeSpent({ data, loading }: Props) {
  if (loading || !data) return <div className="empty-state">Indlæser…</div>

  return (
    <div className="timespent-grid">
      <div className="timespent-box">
        <div className="kpi-label">Tid til lead</div>
        <div className="timespent-value">
          {data.timeToLead.medianMs !== null
            ? formatDuration(data.timeToLead.medianMs)
            : <span className="muted">—</span>}
        </div>
        {data.timeToLead.count > 0 ? (
          <div className="timespent-meta">
            Median af {data.timeToLead.count} leads<br />
            Gns: {formatDuration(data.timeToLead.avgMs ?? 0)}
          </div>
        ) : (
          <div className="timespent-meta">Ingen data endnu</div>
        )}
      </div>
      <div className="timespent-box">
        <div className="kpi-label">Tid ved frafald</div>
        <div className="timespent-value">
          {data.timeToAbandon.medianMs !== null
            ? formatDuration(data.timeToAbandon.medianMs)
            : <span className="muted">—</span>}
        </div>
        {data.timeToAbandon.count > 0 ? (
          <div className="timespent-meta">
            Median af {data.timeToAbandon.count} frafald<br />
            Gns: {formatDuration(data.timeToAbandon.avgMs ?? 0)}
          </div>
        ) : (
          <div className="timespent-meta">Ingen data endnu</div>
        )}
      </div>
    </div>
  )
}
